"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Dashboard = function Dashboard(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "dashboard",
    viewBox: "0 0 20 20"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-24.000000, -133.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("g", {
    transform: "translate(14.000000, 123.000000)"
  }, react_1["default"].createElement("path", {
    d: "M20,10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z M23.5,13.9378222 L21.98097,20.2790659 C21.9462555,20.5260874 21.8644357,20.7707027 21.7320508,21 C21.1797661,21.9565852 19.9565852,22.2843356 19,21.7320508 C18.0434148,21.1797661 17.7156644,19.9565852 18.2679492,19 L18.2679492,19 L18.2679492,19 C18.3733817,18.8185864 18.4986757,18.6637758 18.6408953,18.53202 L18.6561751,18.5131152 L23.5,13.9378222 Z"
  })))));
};

exports["default"] = Dashboard;